import {Combobox as ComboboxPrimitive} from '@base-ui/react/combobox'

import {InputText, InputTextProps} from '@components/commons/input-text'
import {cn} from '@utilities/helpers'

export const Combobox = ComboboxPrimitive.Root

export const ComboboxTrigger = (props: ComboboxPrimitive.Trigger.Props) => (
    <ComboboxPrimitive.Trigger data-slot="combobox-trigger" {...props} />
)

export const ComboboxList = ({className, ...props}: ComboboxPrimitive.List.Props) => (
    <ComboboxPrimitive.List data-slot="combobox-list" className={cn('w-full', className)} {...props} />
)

export const ComboboxEmpty = ({className, ...props}: ComboboxPrimitive.Empty.Props) => (
    <ComboboxPrimitive.Empty data-slot="combobox-empty" className={cn('w-full', className)} {...props} />
)

export const ComboboxItem = ({className, ...props}: ComboboxPrimitive.Item.Props) => (
    <ComboboxPrimitive.Item
        data-slot="combobox-item"
        className={cn(
            'cursor-pointer flex items-center gap-2 p-4 text-md select-none hover:bg-neutral-100 data-highlighted:bg-neutral-100',
            className
        )}
        {...props}
    />
)

type ComboboxContentProps = ComboboxPrimitive.Popup.Props &
    Pick<ComboboxPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset' | 'anchor'> & {
        positionerClassName?: string
    }

export const ComboboxContent = ({
    align = 'start',
    alignOffset = 0,
    side = 'bottom',
    sideOffset = 4,
    anchor,
    className,
    positionerClassName,
    ...props
}: ComboboxContentProps) => (
    <ComboboxPrimitive.Portal>
        <ComboboxPrimitive.Positioner
            data-slot="combobox-positioner"
            className={cn('isolate z-modal-dropdown w-(--anchor-width) outline-none', positionerClassName)}
            align={align}
            alignOffset={alignOffset}
            side={side}
            sideOffset={sideOffset}
            anchor={anchor}
        >
            <ComboboxPrimitive.Popup
                data-slot="combobox-content"
                className={cn(
                    'w-full max-h-(--available-height) origin-(--transform-origin) overflow-y-auto rounded-lg border border-neutral-300 bg-white shadow-md outline-none',
                    className
                )}
                {...props}
            />
        </ComboboxPrimitive.Positioner>
    </ComboboxPrimitive.Portal>
)

type ComboboxInputProps = ComboboxPrimitive.Input.Props & Omit<InputTextProps, 'type' | 'touched' | 'visibilityToggle'>

export const ComboboxInput = ({startSlot, variant, inputSize, className, ...props}: ComboboxInputProps) => {
    return (
        <ComboboxPrimitive.Input
            render={
                <InputText
                    type="text"
                    startSlot={startSlot}
                    variant={variant}
                    inputSize={inputSize}
                    className={className}
                />
            }
            {...props}
        />
    )
}
